module.exports = __webpack_public_path__ + "img/icons8-traffic-light.fc631acc.svg";